const API_TYPES = {
  PUBLIC: 'public',
  PRIVATE: 'private',
  EDITOR: 'editor',
}

const REF_COMP_TYPE = 'wysiwyg.viewer.components.RefComponent'
const APP_WIDGET_TYPE = 'platform.components.AppWidget'
const STUDIO_WIDGET_TYPE = 'STUDIO_WIDGET'
const BUILDER_COMPONENT_TYPE_PREFIX = 'platform.builder'

const isWebWorker = () =>
  typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope

const isNodeWorker = () => {
  return typeof process !== 'undefined'
}

const isWorker = () => isWebWorker() || isNodeWorker()

const isMainFrame = () =>
  typeof window !== 'undefined' && window === window.parent

const getWindow = () => window

const getApiName = (appDefinitionId, apiType) =>
  `platform_${apiType}_${appDefinitionId}`

const isComponentBelongsToApp = async (api, token, componentRef, appData) => {
  const componentType = await api.document.components.getType(appData, token, {
    componentRef: componentRef.documentPointer || componentRef,
  })

  if (componentType === REF_COMP_TYPE || componentType === APP_WIDGET_TYPE) {
    const widgetData = await api.document.components.data.get(appData, token, {
      componentRef,
    })

    return appData?.appDefinitionId === widgetData?.appDefinitionId
  }

  const app = await api.document.application.getAppDataByAppDefId(
    appData,
    token,
    appData.appDefinitionId,
  )

  const isCompBelongsToApp = app.components.some(
    ({type, data}) =>
      type === STUDIO_WIDGET_TYPE &&
      data?.componentModel?.componentType === componentType,
  )

  return isCompBelongsToApp
}

const isBuilderComponentType = (compType) =>
  compType.startsWith(BUILDER_COMPONENT_TYPE_PREFIX)

export {
  API_TYPES,
  isWebWorker,
  isNodeWorker,
  isWorker,
  isMainFrame,
  getWindow,
  getApiName,
  isComponentBelongsToApp,
  isBuilderComponentType,
}
